import React from 'react';

const Cart = (props) => {
    console.log(props)
    const cart = props.cart;
    let totalEarnings = cart.reduce( (total, player) => total + player.earning ,0)

    return (

        <div>
            <h3>Total selected players: {cart.length}</h3>
            <p className="text-end">total Cost: ${totalEarnings}</p>
            {cart.map(player => 
            <ul className="border">
                <li>name:{player.name}</li>
                <p><small>Earning: ${player.earning}</small></p>
                
            </ul>
        
            )}
            
        </div>
    );
};

export default Cart;